module.exports = __webpack_public_path__ + "static/media/face_painter_temp.93166966.jpg";